import { Component, Input, OnInit, signal, computed, inject, DestroyRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatDividerModule } from '@angular/material/divider';

@Component({
    selector: 'app-linear-loading',
    templateUrl: './linear-loading.component.html',
    standalone: true,
    imports: [
        CommonModule,
        MatProgressBarModule,
        MatDividerModule
    ]
})
export class LinearLoadingComponent implements OnInit {
    private destroyRef = inject(DestroyRef);

    // Traditional input property
    @Input() loading: boolean = true;

    // Computed properties
    isLoading = computed(() => this.loading);
    showProgress = computed(() => this.isLoading());

    constructor() { }

    ngOnInit(): void {
        // Component initialization logic can go here
    }
}
